import {apolloClient, gql} from '../graphql';
import {logAndThrowGraphQLErrors, normalizeGraphQLObject} from '../graphql/helpers';
import {formatIsoDate, parseIsoDate} from 'shared/src/datetime';
import type {ID, Trip} from 'shared/src/models';

export const createTrip = async (newTrip: Omit<Trip, 'id'>): Promise<Trip> => {
	const {data, errors} = await apolloClient.mutate({
		mutation: gql(/* GraphQL */ `
			mutation CreateTrip($newTrip: NewTripInput) {
				createTrip(newTrip: $newTrip) {
					id
				}
			}
		`),
		variables: {
			newTrip: {
				...newTrip,
				tripDate: formatIsoDate(newTrip.tripDate),
			},
		},
	});

	if (errors && errors.length > 0) {
		logAndThrowGraphQLErrors(errors);
	}

	return {
		...newTrip,
		id: data!.createTrip.id,
	};
};

export const getTrips = async ({year}: {year: number}): Promise<Trip[]> => {
	const {data, error} = await apolloClient.query({
		query: gql(/* GraphQL */ `
			query GetTrips($year: Int!) {
				trips(year: $year) {
					id
					tripDate
					destination
					mileage
					memo
				}
			}
		`),
		variables: {
			year,
		},
		fetchPolicy: 'no-cache',
	});

	if (error) {
		throw error;
	}

	return data.trips.map((trip) => ({
		...normalizeGraphQLObject(trip),
		tripDate: parseIsoDate(trip.tripDate),
	}));
};

export const deleteTrip = async (tripId: ID): Promise<void> => {
	const {errors} = await apolloClient.mutate({
		mutation: gql(/* GraphQL */ `
			mutation DeleteTrip($tripId: ID!) {
				deleteTrip(id: $tripId)
			}
		`),
		variables: {
			tripId,
		},
	});

	if (errors && errors.length > 0) {
		logAndThrowGraphQLErrors(errors);
	}
};
